// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"1bffe234-567":"e71ac0790ad8d38bf8f3","1bffe234-452":"ca83bfae6eba131a6e28","1bffe234-812":"81aa4b5c43ebccc9a3bc","1bffe234-83":"85c830f5cf7c46b265f7"}[chunkId] + ".js";
};